import { get, patch, post, put, putFile, destroy } from './';

export const getTripAccommodationLabels = ({ tripId, locale }) => {
  return get(
    `/api/v1/trip/${tripId}/accommodation-labels?locale=${locale ?? 'en'}`,
  );
};

// KD-3788: descriptive content of a product placed on the trip, served even
// when the DMC no longer distributes it — the same lean payload the shared
// travel diary reads, with no price.
export const getTripDiaryExperience = ({ tripId, experienceId, locale }) => {
  return get(
    `/api/v1/trip/${tripId}/diary-experiences/${experienceId}?locale=${locale ?? 'en'}`,
  );
};

export const getTrip = ({ tripId, versionId, locale }) => {
  const params = new URLSearchParams();
  if (versionId) {
    params.set('version', versionId);
  }
  if (locale) {
    params.set('locale', locale);
  }
  const query = params.toString();

  return get(`/api/v1/trip/${tripId}${query ? `?${query}` : ''}`);
};

export const getOneTrip = ({ tripId }) => {
  return get(`/api/v1/trip/${tripId}`);
};

export const saveTrip = trip => {
  return post(`/api/v1/trip/save`, trip);
};

export const updateTrip = (tripId, data) => {
  return patch(`/api/v1/trip/${tripId}`, data);
};

export const saveTripDays = ({
  tripId,
  tripDays,
  folderId,
  draftPrice,
  travelers,
  globalOptions,
}) => {
  return put(`/api/v1/trip/${tripId}/days`, {
    tripDays,
    folderId,
    draftPrice,
    travelers,
    globalOptions,
  });
};

export const saveTripTemplate = ({ tripId, body }) => {
  return post(`/api/v1/trip/${tripId}/template`, body);
};

export const archiveTripTemplate = ({ templateId }) => {
  return destroy(`/api/v1/trip-templates/${templateId}`);
};

export const restoreTripTemplate = ({ templateId }) => {
  return patch(`/api/v1/trip-templates/${templateId}/restore`);
};

export const getTripPrograms = ({ filters, locale }) => {
  return post(`/api/v1/trip/programs?locale=${locale ?? 'en'}`, filters);
};

export const getTripsBooked = ({ filters, locale }) => {
  return post(`/api/v1/trip/booked?locale=${locale ?? 'en'}`, filters);
};

export const getTripConversations = ({ tripId, filters }) => {
  return post(`/api/v1/trip/${tripId}/conversation`, filters);
};

export const getTripConversationMessage = ({ tripId, conversationId }) => {
  if (!tripId || !conversationId) {
    return Promise.resolve(null);
  }
  return get(`/api/v1/trip/${tripId}/conversation/${conversationId}/message`);
};

export const sendMessage = ({ tripId, conversationId, body }) => {
  return post(
    `/api/v1/trip/${tripId}/conversation/${conversationId}/message/`,
    body,
  );
};

export const createTripConversations = ({ tripId, body }) => {
  return post(`/api/v1/trip/${tripId}/conversation/create`, body);
};

export const closeTripConversations = (tripId, conversationId) => {
  return put(`/api/v1/trip/${tripId}/conversation/${conversationId}`);
};

export const getTripDocuments = ({ tripId, conversationId }) => {
  return get(`/api/v1/trip/${tripId}/conversation/${conversationId}/document`);
};

export const createTripDocument = ({ tripId, conversationId, data }) => {
  return putFile(
    `/api/v1/trip/${tripId}/conversation/${conversationId}/document`,
    data,
  );
};

export const getConversation = conversationId => {
  return get(`/api/v1/trip/conversations/${conversationId}`);
};

export const getTripDocument = ({ tripId, conversationId, documentId }) => {
  return get(
    `/api/v1/trip/${tripId}/conversation/${conversationId}/document/${documentId}`,
    { responseType: 'blob' },
    false,
  );
};

export const getTripBookings = ({ tripId, skip = false }) => {
  if (skip) {
    return Promise.resolve([]);
  }
  return get(`/api/v1/trip/${tripId}/bookings`);
};
